import React, { useRef, useState } from 'react'
import styles from './GioCaoDiem.module.css';
import { GRID_SIZE } from './GioCaoDiem';

const carsPos = {};
export const Car = ( {car, cars, lock, win, setStep, gridSize} ) => {
    const CELL_SIZE = gridSize.width/GRID_SIZE;
    const CAR_SIZE = CELL_SIZE * 0.7;
    const offset = CELL_SIZE * 0.15;
    
    const hCell = car.direction === 'vertical' ? car.length : 1;
    const wCell = car.direction === 'horizontal' ? car.length : 1;
    const [ pos, setPos ] = useState(() => ({
        top: (car.row - 1) * CELL_SIZE + offset * hCell,
        left: (car.col - 1) * CELL_SIZE + offset * wCell
    }));
    const startMousePos = useRef({x : 0, y : 0});
    const dragging = useRef(false)

    const xLeft = pos.left - offset * wCell;
    const xRight = pos.left + CAR_SIZE * wCell + offset * wCell;
    const yTop = pos.top - offset * hCell;
    const yBottom = pos.top + CAR_SIZE * hCell + offset*hCell;
    carsPos[car.id] = {xLeft, xRight, yTop, yBottom}

    const startPos = useRef({top: pos.top, left: pos.left});
    const startFollowMousePos = useRef({top: pos.top, left: pos.left})
    const [applyTransition, setApplyTransition] = useState(false);
    const [previewPos, setPreviewPos] = useState(null);


    function getSnappedPosition(pos, dir) {
        let cell = Math.round(pos / CELL_SIZE);
        if(car.direction === dir && cell + car.length > 6) {
            if(car.id !== 0 || car.exit_edge === 'exit-top' || car.exit_edge === 'exit-left') {
                cell = GRID_SIZE - car.length;
            } 
        }

        return  cell * CELL_SIZE;
    }

    function isInsideGrid(newRow, newCol) {
        if(car.id === 0) {
            if(car.exit_edge === 'exit-top') return newRow >= -1 && newRow + car.length * 0.7 < GRID_SIZE;
            if(car.exit_edge === 'exit-bottom') return newRow >= 0 && newRow + car.length * 0.7 < GRID_SIZE + 1;
            if(car.exit_edge === 'exit-right') return newCol >= 0 && newCol + car.length * 0.7 < GRID_SIZE + 1;
            if(car.exit_edge === 'exit-left') return newCol >= -1 && newCol + car.length * 0.7 < GRID_SIZE;
        }
        if (car.direction === 'horizontal') {
          return newCol >= 0 && newCol + car.length * 0.7 <= GRID_SIZE;
        }
        return newRow >= 0 && newRow + car.length * 0.7 <= GRID_SIZE;
    }

    function isCollidingCar(curXLeft, curXRight, curYTop, curYBottom) {
        let isColliding = false;
        const d = 2;
        curXLeft += d;
        curXRight -= d;
        curYTop += d;
        curYBottom -= d;

        for(let c of cars) {
            if(c.id === car.id) continue
            const otherCarPos = carsPos[c.id];
            
            if(
                curXLeft < otherCarPos.xRight && curXRight > otherCarPos.xLeft &&
                curYTop < otherCarPos.yBottom && curYBottom > otherCarPos.yTop
            ) {
                isColliding = true;
                console.log("curID: " + car.id);
                console.log('' + curXLeft + ' ' + curXRight + ' ' + curYTop + ' ' + curYBottom + '')
                console.log("colide id: " + c.id);
                console.log(otherCarPos)
            }
        }

        return isColliding;
    }

    const handleTouchStart = (e) => {
        window.addEventListener('touchstart', handleMouseDown, {passive: false})
    }

    const handleMouseDown = (e) => {
        if(lock) return;
        setApplyTransition(false);
        e.preventDefault();
        e.stopPropagation();

        console.log("mouse down");
        console.log("click type: " + e.type)

        let clientX = 0;
        let clientY = 0;

        if(e.type.startsWith("mouse")) {
            clientX = e.clientX;
            clientY = e.clientY;
        } else if(e.type.startsWith("touch")) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        }
        console.log("x: "+ clientX + " y: " + clientY)
        
        startMousePos.current = {
            x: clientX,
            y: clientY
        }
        dragging.current = true;
        startPos.current = ({top: pos.top, left: pos.left})
        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
        window.addEventListener("touchmove", handleMouseMove, {passive: false});
        window.addEventListener("touchend", handleMouseUp);
        window.removeEventListener('touchstart', handleMouseDown, {passive: false})
    }

    const handleMouseMove = (e) => {
        if(!dragging.current) return 0;
        e.preventDefault();
        e.stopPropagation();
        console.log("Handle mouse move")
        let clientX = 0;
        let clientY = 0;

        if(e.type.startsWith("mouse")) {
            clientX = e.clientX;
            clientY = e.clientY;
        } else if(e.type.startsWith("touch")) {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
        }
        const dx = clientX - startMousePos.current.x;
        const dy = clientY - startMousePos.current.y;

        let newLeft = pos.left;
        let newTop = pos.top;

        if(car.direction === 'vertical') {
            newTop += dy;
        } else if(car.direction === 'horizontal') {
            newLeft += dx;
        }

        const newRow = newTop / CELL_SIZE;
        const newCol = newLeft / CELL_SIZE;
        const isInside = isInsideGrid(newRow, newCol);

        const curXLeft = startFollowMousePos.current.left - offset * wCell;
        const curXRight = car.direction === 'horizontal' ? startFollowMousePos.current.left + CAR_SIZE * car.length + offset * car.length: startFollowMousePos.current.left + CAR_SIZE;
        const curYTop = startFollowMousePos.current.top - offset * hCell;
        const curYBottom = car.direction === 'vertical' ?  startFollowMousePos.current.top + CAR_SIZE * car.length + offset * car.length: startFollowMousePos.current.top + CAR_SIZE;
        const isColliding = isCollidingCar(curXLeft, curXRight, curYTop, curYBottom);

        if(isInside && !isColliding) {
            setPos({top: newTop, left: newLeft});
            startPos.current = ({top: newTop, left: newLeft});
        }
        
        startFollowMousePos.current = ({top: newTop, left: newLeft});
        const snappedTop = getSnappedPosition(newTop, 'vertical') + offset * hCell;
        const snappedLeft = getSnappedPosition(newLeft, 'horizontal') + offset * wCell;
        setPreviewPos({ top: snappedTop, left: snappedLeft });

    }

    const handleMouseUp = (e) => {
        console.log("mouse up")

        let clientX = 0;
        let clientY = 0;

        if(e.type.startsWith("mouse")) {
            clientX = e.clientX;
            clientY = e.clientY;
        } else if(e.type.startsWith("touch")) {
            clientX = e.changedTouches[0].clientX;
            clientY = e.changedTouches[0].clientY;
        }

        dragging.current = false;
        let snappedTop = getSnappedPosition(startPos.current.top, 'vertical') + offset*hCell;
        let snappedLeft = getSnappedPosition(startPos.current.left, 'horizontal') + offset*wCell;

        let isColliding = false
        let count = 0;
        do {
            isColliding = false;
            count++;
            const curXLeft = snappedLeft + 10;
            const curXRight = snappedLeft + wCell * CAR_SIZE - 10;
            const curYTop = snappedTop + 10;
            const curYBottom = snappedTop + hCell * CAR_SIZE - 10;
            isColliding = isCollidingCar(curXLeft, curXRight, curYTop, curYBottom);
            if(isColliding) {
                console.log("collding")
                console.log("snappedLeft: " + snappedLeft)
                console.log("xLeft: " + startPos.current.left)
                if(car.direction === 'horizontal') {
                    if(snappedLeft > startPos.current.left) snappedLeft -= CELL_SIZE;
                    else snappedLeft += CELL_SIZE
                } else {
                    if(snappedTop > startPos.current.top) snappedTop -= CELL_SIZE;
                    else snappedTop += CELL_SIZE
                }
            }
        } while(isColliding && count < 3)
        

        const newRow = Math.floor(snappedTop/CELL_SIZE);
        let newCol = Math.floor(snappedLeft/CELL_SIZE);
        const oldRow = Math.floor(pos.top/CELL_SIZE);
        const oldCol = Math.floor(pos.left/CELL_SIZE);
        console.log('newRow: ' + newRow + " newCol: " + newCol + " oldRow: " + oldRow + " oldCol: " + oldCol)
        
        if (!isColliding) {
            setPos({top: snappedTop, left: snappedLeft})
        }
        
        window.removeEventListener('mousemove', handleMouseMove);
        window.removeEventListener('mouseup', handleMouseUp);
        window.removeEventListener('touchmove', handleMouseMove, {passive: false});
        window.removeEventListener('touchend', handleMouseUp);
        startPos.current = ({top: pos.top, left: pos.left});

        startMousePos.current = {
            x: clientX,
            y: clientY
        }

        //check win
        if(car['exit_edge']) {
            const exit_edge = car.exit_edge;
            if(
                (exit_edge === 'exit-top' && snappedTop) < 0 ||
                (exit_edge === 'exit-bottom' && snappedTop + CAR_SIZE * hCell > gridSize.height) ||
                (exit_edge === 'exit-left' && snappedLeft < 0) ||
                (exit_edge === 'exit-right' && snappedLeft + CAR_SIZE * wCell > gridSize.width)
            ) {
                win()
                newCol - oldCol >= 0 ? newCol++ : newCol-- //tăng tổng số step lên 1
            }
        }

        setStep(prev => prev + Math.abs(newRow - oldRow) + Math.abs(newCol - oldCol))
        setApplyTransition(true);
        setPreviewPos(null);

    }

    return (
        <>
          <div
            key={car.id}
            className={`${styles.car} ${applyTransition ? styles.transition : ''}`}
            style={{
              top: pos.top,
              left: pos.left,
              width: wCell * CAR_SIZE,
              height: hCell * CAR_SIZE,
              backgroundColor: car.color,
            }}
            onMouseDown={handleMouseDown}
            onTouchStart={handleTouchStart}
          ></div>
      
          {previewPos && (
            <div
              className={`${styles.car} ${styles.preview}`}
              style={{
                top: previewPos.top,
                left: previewPos.left,
                width: wCell * CAR_SIZE,
                height: hCell * CAR_SIZE,
                backgroundColor: 'rgba(0,0,0,0.2)',
                pointerEvents: 'none',
                zIndex: 0,
              }}
            ></div>
          )}
        </>
      );
}